import BasketCustomerAutocomplete from './BasketCustomerAutocomplete'
import CategoryAutocomplete from './CategoryAutocomplete'
import CustomerAutocomplete from './CustomerAutocomplete'
import ManufacturerAutocomplete from './ManufacturerAutocomplete'
import RHFAutocompleteBase from './RHFAutocomplete'

type RHFAutocompleteType = typeof RHFAutocompleteBase & {
	BasketCustomer: typeof BasketCustomerAutocomplete
	Customer: typeof CustomerAutocomplete
	Category: typeof CategoryAutocomplete
	Manufacturer: typeof ManufacturerAutocomplete
}

const RHFAutocomplete = RHFAutocompleteBase as RHFAutocompleteType

RHFAutocomplete.BasketCustomer = BasketCustomerAutocomplete
RHFAutocomplete.Customer = CustomerAutocomplete
RHFAutocomplete.Category = CategoryAutocomplete
RHFAutocomplete.Manufacturer = ManufacturerAutocomplete

export default RHFAutocomplete
